(function($) {

  $(document).ready(function() {
    collection.init();
  });

  if ($(".collection-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!collection.fillterClick) {
        collection.filterParams();
        var newurl = collection.filterCreateUrl();
        collection.filterGetContent(newurl);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }

  var collection = {
    init: function() {
      /* Collection Filter */
      this.initCollectionFilter();

      /* Collection Sorting */
      this.initCollectionSorting();

      /* Collection Show */
      this.initCollectionShow();

      /* Collection ViewMode */
      this.initCollectionViewMode();

      /* Paging */
      this.initPaging();

      this.initExpandToggle();

      this.initFilterSearch();
      this.initFilterShorten();
      this.initFilter();
    },

    initExpandToggle: function(){
      $('.content-toggle').on('click', function(e){
        e.preventDefault();
        var $desc = $(this).siblings('.collection-description__collapse');
        if ( $desc.hasClass('expanded') ) {
          $desc.removeClass('expanded');
          $('body,html').animate({
              scrollTop: 0
            }, 300);
        } else {
          $desc.addClass('expanded');
        }
      });
    },

    /* Hide Dropdown */
    initToggle: function(){
      $('.caret').click(function() {
        $(this).parent().next().toggleClass('active');
        return false;
      });

      $(".block-category .sub-menu > li").each( function(){
        if($(this).hasClass('active')){
          $(this).parent().addClass('active');
        }
      });

      $('.dropdown-toggle').click(function() {
        $('.dropdown-content').removeClass('active');
        $(this).next().toggleClass('active');
        return false;
      });
    },

    /* --------------------------------------------------------- */
    /* Categories Fillter */

    filterCategories: function() {
      $(".block-category.ajax a").click(function(e) {
        if (!$(this).hasClass('active')) {
          delete Shopify.queryParams.q;
          collection.filterAjaxClick($(this).attr('href'));
          $(".block-category.ajax a.active").removeClass("active");
          $(this).addClass("active");
        }
        e.preventDefault();
      });
    },

    fillterTagEvents: function() {
      $('.filter-tag li a, .filter-tag label').click(function(e) {
        var currentTags = [];
        if (Shopify.queryParams.constraint) {
          currentTags = Shopify.queryParams.constraint.split('+');
        }

        if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {
          var otherTag = $(this).parents('.filter-tag').find("input:checked");
          if (otherTag.length > 0) {
            var tagName = otherTag.val();
            if (tagName) {
              var tagPos = currentTags.indexOf(tagName);
              if (tagPos >= 0) {
                currentTags.splice(tagPos, 1);
              }
            }
          }
        }

        var tagName = $(this).prev().val();
        if (tagName) {
          var tagPos = currentTags.indexOf(tagName);
          if (tagPos >= 0) {
            currentTags.splice(tagPos, 1);
          } else {
            currentTags.push(tagName);
          }
        }

        // shopby-brand filter hack
        var lang = $('html').attr('lang');
        for(var i=0; i<currentTags.length; i++) {
          if (currentTags[i].startsWith('_vendor')) {
            if (
              (lang === 'en' && !currentTags[i].startsWith('_vendor_EN')) ||
              (lang === 'zh-TW' && !currentTags[i].startsWith('_vendor_ZT'))
            ) {
              currentTags.splice(i, 1);
            }
          }
        }

        if (currentTags.length) {
          Shopify.queryParams.constraint = currentTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClearAll: function() {
      //clear all selection
      $('.refined-widgets a.clear-all').click(function(e) {
        delete Shopify.queryParams.constraint;
        delete Shopify.queryParams.q;
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var filterTag = $(this);
        if (filterTag.find("input:checked").length > 0) {
          //has active tag
          filterTag.find(".clear").show().click(function(e) {
            var currentTags = [];
            var tagsFromUrl = Shopify.queryParams.constraint || $('.collection-info').data('current-tag');
            if (tagsFromUrl) {
              currentTags = tagsFromUrl.split('+');
            }
            filterTag.find("input:checked").each(function() {
              var selectedTag = $(this);
              var tagName = selectedTag.val();
              if (tagName) {
                var tagPos = currentTags.indexOf(tagName);
                if (tagPos >= 0) {
                  //remove tag
                  currentTags.splice(tagPos, 1);
                }
              }
            });
            if (currentTags.length) {
              Shopify.queryParams.constraint = currentTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }
            collection.filterAjaxClick($('.collection-info').data('collection-url'));
            e.preventDefault();
          });
        }
      });
    },

    filterParams: function() {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    filterMapEvents: function() {
      collection.fillterTagEvents();
      collection.filterCategories();
    },

    resetFilter: function() {
      $(".filter-custom .active, .filter-links .active").removeClass("active");
      $(".filter-tag input:checked").attr("checked", false);

      //category
      var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
      if (cat && cat[1]) {
        $(".filter-links a[href='" + cat[0] + "']").addClass("active");
      }
    },

    filterMapData: function(data) {
      var currentList = $(".collection-grid");
      if (currentList.length == 0) {
        currentList = $(".collection-list");
      }

      var productList = $(data).find(".collection-grid");
      if (productList.length == 0) {
        productList = $(data).find(".collection-list");
      }
      if (productList.length > 0 && productList.hasClass("products-grid")) {
        if (window.product_image_resize) {
          productList.find('img').fakecrop({
            fill: window.images_size.is_crop,
            widthSelector: ".products-grid .grid-item .product-image",
            ratioWrapper: window.images_size
          });
        }
      }
      currentList.replaceWith(productList);


      //replace paging
      if ($(".pagination").length > 0) {
        $(".pagination").replaceWith($(data).find(".pagination"));
      }

      //replate sidebar
      $(".filter-block").replaceWith($(data).find(".filter-block"));
      $(".collection-sidebar .filter-custom").each(function() {
        var isShorten = $(this).find(".scrollbar-outer").hasClass("is-shorten");
        $(this).find(".scrollbar-outer").toggleClass("is-shorten", isShorten);
      });

      //replace view count
      if ($(".view-count").length > 0) {
        $(".view-count").html($(data).find(".view-count").html());
      }

      //replace title & description
      var currentHeader = $(".collection-info");
      var dataHeader = $(data).find(".collection-info");

      if (currentHeader.find("h3").text() != dataHeader.find("h3").text()) {
        currentHeader.find("h3").replaceWith(dataHeader.find("h3"));
        if (currentHeader.find(".c-des").length) {
          if (dataHeader.find(".c-des").length) {
            currentHeader.find(".c-des").replaceWith(dataHeader.find(".c-des"));
          }
        }
      }
    },

    filterCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {

        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },

    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = collection.filterCreateUrl(baseLink);
      collection.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, document.title, newurl);
      collection.filterGetContent(newurl);
    },

    filterGetContent: function(newurl) {

      $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          gred.showPopup('.fpu-loading');
        },

        success: function(data) {
          collection.filterMapData(data);

          collection.filterMapClear();
          collection.filterMapClearAll();

          collection.filterMapEvents();

          collection.initPaging();
          collection.initToggle();
          collection.initFilterSearch();
          collection.initFilterAjax();

          gred.ConvertCurrency();
          gred.initAddToCart();
          gred.hidePopup('.fpu-loading');

          gred.pagination();
          gred.ConvertCurrency();
          gred.initAddToCart();

          ElecboyTheme.countdown();
        },

        error: function(xhr, text) {
          gred.hidePopup('.fpu-loading')
          $('.error-message').text($.parseJSON(xhr.responseText).description);
          gred.showPopup('.fpu-error');
        }

      });
    },

    initCollectionFilter: function() {
      if ($(".collection-sidebar").length > 0) {
        collection.filterParams();
        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();
      }
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
      $(".collection-sortBy li a").click(function(e) {
        e.preventDefault();
        if (!$(this).parent().hasClass("active")) {
          Shopify.queryParams.sort_by = $(this).attr("href");
          collection.filterAjaxClick();

          $(".collection-sortBy li.active").removeClass("active");
          $(this).parent().addClass("active");
        }
        var selected = $(this).text();
        $(this).closest('.dropdown-toggle').find('.dropdown-label').text(selected);
        $(this).closest('.dropdown-content').removeClass('active');
      });
    },


    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {
      $(".view-mode a").click(function(e) {
        if (!$(this).hasClass("active")) {
          var paging = $(".collection-show .dropdown-label").text();
          if ($(this).hasClass("list")) {
            Shopify.queryParams.view = "list" + paging;
          } else {
            Shopify.queryParams.view = paging;
          }

          collection.filterAjaxClick();
          $(".view-mode a.active").removeClass("active");
          $(this).addClass("active");
        } else{
          return false;
        }
        e.preventDefault();
      });
    },


    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {
      $(".collection-show li a").click(function(e) {
        e.preventDefault();
        if (!$(this).parent().hasClass("active")) {
          var currentPage = $(this).attr('href');
          var view = $(".view-mode a.active").attr("data-mode");
          if (view == "list") {
            Shopify.queryParams.view = "list" + currentPage;
          } else {
            Shopify.queryParams.view = currentPage;
          }
          collection.filterAjaxClick();
          $(".collection-show li.active").removeClass("active");
          $(this).parent().addClass("active");
          $(this).closest('.dropdown-toggle').find('.dropdown-label').text(currentPage);
          $(this).closest('.dropdown-content').removeClass('active');
        }
      });
    },

    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function() {
      /*
      $(".pagination a").click(function(e) {
        var page = $(this).attr("href").match(/page=\d+/g);
        if (page) {
          Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
          if (Shopify.queryParams.page) {
            var newurl = collection.filterCreateUrl();
            collection.fillterClick = true;
            History.pushState({
              param: Shopify.queryParams
            }, newurl, newurl);
            collection.filterGetContent(newurl);
            //go to top
            $('body,html').animate({
              scrollTop: 0
            }, 600);

          }
        }
        e.preventDefault();
      });
      */
    },
    _onFilterShortenItems: function($this) {
      $block = $this.parents('.block');
      $lis = $block.find('li');
      if($block.find('.scrollbar-outer').hasClass('is-shorten')) {
        $lis.removeClass('hide-on-shorten');
        var count = 0;
        $lis.each(function() {
          if (!$(this).hasClass('hide-on-search')) {
            if (count >= 5) {
              $(this).addClass('hide-on-shorten');
            }
            count = count + 1;
          }
        });
      } else {
        $lis.removeClass('hide-on-shorten');
      }
    },
    initFilterShorten: function() {
      var that = this;

      $('.collection-sidebar')
        .on('click', '.filter-length-toggle', function(e){
          e.preventDefault();
          $(this).parents('.scrollbar-outer').toggleClass('is-shorten').css({'display':'block'});
          that._onFilterShortenItems($(this));
        });

      $('.collection-sidebar')
        .on('click', '.filter-toggle', function(e){
          e.preventDefault();
          $(this).parents('.block').toggleClass('filter-collapse');
        });
    },
    initFilterSearch: function() {
      var that = this;
      $('#brand-filter-search').on('input', function(e) {
        e.preventDefault();
        var $that = $(this);
        var $links = $(this).parent().find('li a');
        $links.each(function() {
          var val = $that.val().trim().toLowerCase();
          if (!val || $(this).text().trim().toLowerCase().includes(val)) {
            $(this).parent('li').toggleClass('hide-on-search', false);
          } else {
            $(this).parent('li').toggleClass('hide-on-search', true);
          }
        });
        that._onFilterShortenItems($(this));
      });
    },
    initFilterAjax: function() {
      var that = this;
      $('.collection-sidebar .filter-custom').each(function() {
        $(this).find('.scrollbar-outer').css({'display':'block'});
        if ($(this).find('li').length <= 5) {
          $(this).find('.filter-length-toggle').css('display', 'none');
        }
        var $shortenBtn = $(this).find('.scrollbar-outer').hasClass('is-shorten')
          ? $(this).find('.filter-length-toggle__collapse')
          : $(this).find('.filter-length-toggle__expand');
        that._onFilterShortenItems($shortenBtn);
      })
    },
    initFilter: function() {
      var that = this;
      $('.collection-sidebar .filter-custom').each(function() {
        if ($(this).find('li').length <= 5) {
          $(this).find('.filter-length-toggle').css('display', 'none');
        }
        $(this).find('.scrollbar-outer').css({'display':'none'});
        var $btn = $(this).find('.filter-length-toggle__collapse');
        $btn.parents('.scrollbar-outer').toggleClass('is-shorten').css({'display':'block'});
        that._onFilterShortenItems($btn);
      });
    }
  }

  })(jQuery);
